














































































/* General */

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Components */
import StandardFilterInput from '@/components/global/inputs/standard-filter-input.vue'

/* Helpers */

import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IDashboardOutputProjectsForNavigationProjectForNavigation } from '@/api/types/response.types'

/* API */
import DashboardAPI from '@/api/modules/dashboard.api'

export default SearchableDropdownMixin.extend({
  name: 'BreadcrumbListingPicker',

  components: {
    StandardFilterInput,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    allTasksSelected: {
      type: Boolean,
      default: false,
    },
    allConversationsSelected: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      entitiesLoaded: false,
      entities: [] as IDashboardOutputProjectsForNavigationProjectForNavigation[],
    }
  },

  computed: {
    totalOptionsCount(): number {
      return this.entities.length
    },
    filteredOptions(): IDashboardOutputProjectsForNavigationProjectForNavigation[] {
      return this.entities.filter(entity => {
        return (
          entity.id !== this.selectedId &&
          entity.title.toLowerCase().includes(this.filterQuery.toLowerCase())
        )
      })
    },
    dropdownPlacement(): string {
      return this.$screen.isTabletOrMobile(this.$mq) ? 'bottom' : 'bottom-start'
    },
    selectedEntity(): IDashboardOutputProjectsForNavigationProjectForNavigation {
      return this.entities.find(e => e.id === this.selectedId)
    },
    showMailboxes(): boolean {
      return this.$permissions.isNotGuest
    },
  },

  methods: {
    getIconClassForEntity(
      entity: IDashboardOutputProjectsForNavigationProjectForNavigation,
    ) {
      if (entity.isFavorite) {
        return 'ddi-star-filled'
      }
      return entity.isMailbox ? 'ddi-mailbox' : 'ddi-project'
    },
    async getEntities() {
      if (this.entitiesLoaded) {
        return
      }
      this.entitiesLoaded = false
      try {
        const response = await DashboardAPI.get_ProjectsForNavigation()
        this.entities = response.listEntities
        this.entitiesLoaded = true
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
    sendToEntityHome(
      entity: IDashboardOutputProjectsForNavigationProjectForNavigation,
    ) {
      if (entity.isMailbox) {
        this.sendToMailbox(entity.id)
      } else {
        this.sendToProject(entity.id)
      }
    },
    sendToMailbox(id: number) {
      RouteAssistant.goToMailbox(this.$router, this.$route.params.accountId, id)
    },
    sendToProject(id: number) {
      RouteAssistant.goToProjectLanding(
        this.$router,
        this.$route.params.accountId,
        id,
        this.$permissions,
      )
    },
    sendToAllTasks(id: number) {
      RouteAssistant.goToAllTasks(this.$router, this.$route.params.accountId)
    },
    sendToAllConversations(id: number) {
      RouteAssistant.goToAllConversations(
        this.$router,
        this.$route.params.accountId,
      )
    },
  },
})
